const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";
const TOKEN_KEY = "gbm_access_token";

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number
  ) {
    super(message);
  }
}

export async function apiRequest<T>(
  path: string,
  init: RequestInit = {},
  authenticated = true
): Promise<T> {
  const headers = new Headers(init.headers);
  if (!(init.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  if (authenticated) {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
  }

  let response: Response;
  try {
    response = await fetch(`${API_BASE}${path}`, { ...init, headers });
  } catch {
    throw new ApiError(
      "Không kết nối được backend. Hãy kiểm tra cửa sổ PowerShell chạy API tại cổng 5192.",
      0
    );
  }

  if (!response.ok) {
    let message = `Yêu cầu không thành công (${response.status}).`;
    try {
      const body = (await response.json()) as { message?: string; title?: string };
      message = body.message ?? body.title ?? message;
    } catch {
      // Giữ thông báo mặc định khi phản hồi không phải JSON.
    }
    if (response.status === 401 && authenticated) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem("gbm_auth_user");
    }
    throw new ApiError(message, response.status);
  }

  if (response.status === 204) {
    return undefined as T;
  }
  return (await response.json()) as T;
}

export async function apiDownload(path: string): Promise<Blob> {
  const token = localStorage.getItem(TOKEN_KEY);
  const response = await fetch(`${API_BASE}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined
  });
  if (!response.ok) {
    let message = `Không tải được tệp (${response.status}).`;
    try {
      const body = (await response.json()) as { message?: string };
      message = body.message ?? message;
    } catch {
      // Giữ thông báo mặc định.
    }
    throw new ApiError(message, response.status);
  }
  return response.blob();
}

export { TOKEN_KEY };
